import React from 'react';
import '@fontsource/montserrat';
import Layout from 'components/layout';

export const wrapPageElement = ({ element, props }) => {
  if (props.location.pathname.includes('view-rates')) {
    props.activePage = Object.freeze({
      currentActivePage: Symbol('view-rates'),
    });
    return <Layout {...props}>{element}</Layout>;
  } else if (props.location.pathname.includes('account')) {
    props.activePage = Object.freeze({
      currentActivePage: Symbol('account'),
    });
    return <Layout {...props}>{element}</Layout>;
  } else {
    return <Layout {...props}>{element}</Layout>;
  }
};
